// UX109 (docs/build-briefs/UX109-floor-menu-search.md): the floor menu's
// search matcher. Pure, no DOM. A name matches a query when every word typed
// appears somewhere in the name, ignoring case, accents and punctuation.

/** Letters Unicode decomposition leaves whole, folded by hand. */
const HAND_FOLDED: Readonly<Record<string, string>> = {
  ø: "o",
  đ: "d",
  ł: "l",
  ß: "ss",
  æ: "ae",
  œ: "oe",
};

/** Lower case, accents removed, apostrophes dropped, any other run of
 * non-letter non-digit characters turned into one space, ends trimmed. */
export function foldForSearch(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{M}+/gu, "")
    .toLowerCase()
    .replace(/[øđłßæœ]/g, (ch) => HAND_FOLDED[ch] ?? ch)
    .replace(/['’‘`]/g, "")
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

/** The folded words of a query; empty when there is nothing to match on. */
export function menuQueryWords(query: string): string[] {
  const folded = foldForSearch(query);
  return folded === "" ? [] : folded.split(" ");
}

/** True when the query has no words (an empty or all-punctuation query
 * matches every name), or every word appears anywhere in the name. */
export function nameMatchesMenuQuery(name: string, query: string): boolean {
  const words = menuQueryWords(query);
  if (words.length === 0) {
    return true;
  }
  const folded = foldForSearch(name);
  return words.every((word) => folded.includes(word));
}
